import { render, staticRenderFns } from "./editQuestionWJ.vue?vue&type=template&id=b682063e&scoped=true&"
import script from "./editQuestionWJ.vue?vue&type=script&lang=js&"
export * from "./editQuestionWJ.vue?vue&type=script&lang=js&"
import style0 from "./editQuestionWJ.vue?vue&type=style&index=0&id=b682063e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b682063e",
  null
  
)

export default component.exports